import { render, staticRenderFns } from "./codelogin.vue?vue&type=template&id=16713e97&scoped=true"
import script from "./codelogin.vue?vue&type=script&lang=js"
export * from "./codelogin.vue?vue&type=script&lang=js"
import style0 from "./codelogin.vue?vue&type=style&index=0&id=16713e97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16713e97",
  null
  
)

export default component.exports